import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ValidationSection from '../components/ValidationSection';
import ServicesSection from '../components/ServicesSection';
import HowItWorksSection from '../components/HowItWorksSection';
import WhyNurseSection from '../components/WhyNurseSection';
import WhoItsForSection from '../components/WhoItsForSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';
import CareersSection from '../components/CareersSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main id="main-content" role="main">
        <HeroSection />
        <ValidationSection />
        <ServicesSection />
        <HowItWorksSection />
        <WhyNurseSection />
        <WhoItsForSection />
        <TestimonialsSection />
        <CTASection />
        <CareersSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
